<template>
  <h4
    :id="id"
    :class="[
      'settings-section-title i-text-heading-4 i-text-neutral-120',
      { active: $route.hash === `#${id}` },
    ]"
  >
    <slot />
  </h4>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.settings-section-title {
  border-radius: $border-radius-default;
  background-color: transparent;

  @keyframes background-highlight {
    0% {
      background-color: $color-yellow-60;
    }
    80% {
      background-color: $color-yellow-20;
    }
    100% {
      background-color: transparent;
    }
  }

  &.active {
    animation-name: background-highlight;
    animation-duration: 3s;
  }
}
</style>
